import type { Infer } from 'superstruct';
import { array, assign, object, optional, partial, string } from 'superstruct';

import {
	TargetingGeoLocationCity,
	TargetingGeoLocationCountry,
	TargetingGeoLocationCustomLocation,
	TargetingGeoLocationRegion,
	TargetingGeoLocationZip,
	ViewFacebookAdSetLocationTemplateDto,
} from '@adflow/shared/data-facebook-ads';

import { historyArrayItem } from '../history-array-item';

export const HistoryFacebookAdSetLocationTemplateDto = assign(
	partial(ViewFacebookAdSetLocationTemplateDto),
	partial(
		object({
			// Include avbId for location identification
			avbId: optional(string()),
			locations: optional(
				object({
					cities: optional(
						array(historyArrayItem(partial(TargetingGeoLocationCity)))
					),
					zips: optional(
						array(historyArrayItem(partial(TargetingGeoLocationZip)))
					),
					regions: optional(
						array(historyArrayItem(partial(TargetingGeoLocationRegion)))
					),
					custom_locations: optional(
						array(historyArrayItem(partial(TargetingGeoLocationCustomLocation)))
					),
					countries: optional(
						array(historyArrayItem(partial(TargetingGeoLocationCountry)))
					),
				})
			),
		})
	)
);

export type HistoryFacebookAdSetLocationTemplateDto = Infer<
	typeof HistoryFacebookAdSetLocationTemplateDto
>;
